// @core/api/endpoints/user/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { CheckUserExists } from './check_user_exists';
import { CreateUserInternal } from './create_user_internal';
import { DeleteUser } from './delete_user';
import { GenerateReferralLink } from './generate_referral_link';
import { GetUser } from './get_user';
import { InviteUser } from './invite_user';
import { ListInvitedUsers } from './list_invited_users';
import { ListUsers } from './list_users';
import { UpdateUser } from './update_user';

// Re-export individual endpoints
export {
  CheckUserExists,
  CreateUserInternal,
  DeleteUser,
  GenerateReferralLink,
  GetUser,
  InviteUser,
  ListInvitedUsers,
  ListUsers,
  UpdateUser,
};

// Namespace export for convenient usage
export const userApi = {
  CheckUserExists,
  CreateUserInternal,
  DeleteUser,
  GenerateReferralLink,
  GetUser,
  InviteUser,
  ListInvitedUsers,
  ListUsers,
  UpdateUser,
};
